var _rect, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSummaryAdditional(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55.8809,
    height: 55.8809,
    rx: 14,
    fill: "#FFF5CD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5703 24H36.856C38.22 24 39.5281 24.5418 40.4926 25.5063C41.457 26.4708 41.9989 27.7789 41.9989 29.1429C41.9989 30.5068 41.457 31.8149 40.4926 32.7794C39.5281 33.7439 38.22 34.2857 36.856 34.2857H35.5703",
    stroke: "#FFCB04",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 24H35.5714V35.5714C35.5714 36.9354 35.0296 38.2435 34.0651 39.208C33.1006 40.1724 31.7925 40.7143 30.4286 40.7143H20.1429C18.7789 40.7143 17.4708 40.1724 16.5063 39.208C15.5418 38.2435 15 36.9354 15 35.5714V24Z",
    stroke: "#FFCB04",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1406 15V18.8571",
    stroke: "#FFCB04",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2891 15V18.8571",
    stroke: "#FFCB04",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4219 15V18.8571",
    stroke: "#FFCB04",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryAdditional);
export default __webpack_public_path__ + "static/media/summary-additional.3fd15472952ab939e75912264e3fe0ae.svg";
export { ForwardRef as ReactComponent };